'use strict';

export function init() {
    const eventNav = document.querySelector(".event-nav");

    let eventNavWidth = 0;
    if (eventNav) {
        eventNavWidth = eventNav.getBoundingClientRect().width;
    }
    

    if (!eventNav) {
        return false;
    }

    document.documentElement.style.setProperty('--event-nav-width', `${eventNavWidth}px`);

    window.addEventListener('resize', () => {
        eventNavWidth = eventNav.getBoundingClientRect().width;
        document.documentElement.style.setProperty('--event-nav-width', `${eventNavWidth}px`);
    });
}
